/* eslint-disable react-hooks/rules-of-hooks */
import './assets/scss/index.css';
// routing
import Routes from 'routes';

// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';
import ThemeCustomization from 'themes';

// auth provider
// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
import axios from 'axios';
// import JWTContext, { JWTProvider } from 'contexts/JWTContext';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
import JWTContext, { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import { useEffect } from 'react';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';
import { useLocation, useNavigate } from 'react-router-dom';

// ==============================|| AXIOS CONFIG BASED ON PORT ||=============================== //

const frontendPort = window.location.port;

if (frontendPort === '3000') {
    axios.defaults.baseURL = 'https://api.ustmentrar.com/api'; // backend for port 3000
}
// } else if (frontendPort === '3001') {
//     axios.defaults.baseURL = 'http://192.168.68.158:5001/api'; // backend for port 3001
// } else if (frontendPort === '3002') {
//     axios.defaults.baseURL = 'http://192.168.68.149:5002/api'; // backend for port 3002
else {
    axios.defaults.baseURL = 'https://api.ustmentrar.com/api'; // fallback backend
}

// ==============================|| APP ||=============================== //

const App = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const { pathname } = location;
        if (pathname === '/') {
            navigate('/login');
        }
    }, [location, navigate]);

    return (
        <ThemeCustomization>
            <RTLLayout>
                <Locales>
                    <NavigationScroll>
                        <AuthProvider>
                            <>
                                <Routes />
                                <Snackbar />
                            </>
                        </AuthProvider>
                    </NavigationScroll>
                </Locales>
            </RTLLayout>
        </ThemeCustomization>
    );
};

export default App;
